import React from 'react';
import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const LawFirmCardTitle: React.FC<Props> = (props) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle>{props.children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
